import _throttle from 'lodash.throttle'
import Sortable from 'sortablejs';
import IMask from 'imask';
import SmoothScroll from 'smooth-scroll';

const formScroll = new SmoothScroll('.scrollll',{
  speed: 500,
  updateURL: false,
  offset: 100
});

const formValidation = () => {

  const forms = document.querySelectorAll('.wpcf7');

  if(forms) {
    forms.forEach(form => {

      // # repeater

      const repeaters = form.querySelectorAll('.wpcf7cf_repeater');
      if(repeaters) {
        repeaters.forEach(repeater => {
          const add = repeater.querySelector('.wpcf7cf_add');
          const addText = add.innerText;

          add.innerHTML = '<span><span class="c-btn c-btn--is-icon"><svg class="c-btn__icon"><use xlink:href="#icon-plus"></use></svg></span>'+ addText+'</span>';

          const remove = repeater.querySelector('.wpcf7cf_remove');
          const removeText = remove.innerText;

          remove.innerHTML = '<span><span class="c-btn c-btn--is-icon"><svg class="c-btn__icon"><use xlink:href="#icon-minus"></use></svg></span>'+ removeText+'</span>';
        });
      }

      // # sortable lists

      const sortValues = form.querySelector('[name="expose_selection"]');
      const listResult = form.querySelector('[data-sortable-list="result"]');
      if(listResult) {
        const sListResult = Sortable.create(listResult,{
          animation: 150,
          delay: 150,
          delayOnTouchOnly: true,
          easing: "cubic-bezier(1, 0, 0, 1)",
          dragoverBubble: true,
          group: {
            name: 'expose-sort',
            put: function (to) {
              return to.el.children.length < 3;
            }
          },
          onEnd: function (evt) {
            const items = evt.from.querySelectorAll('.c-sortable__item')
            if(items) {
              if(items.length < 3) {
                evt.from.classList.remove('c-sortable--max');
              } else {
                evt.from.classList.add('c-sortable--max');
              }
              if(items.length < 1) {
                evt.from.classList.remove('c-sortable--visible');
              } else {
                evt.from.classList.add('c-sortable--visible');
              }
              let resultItems = [];
              items.forEach(item => {
                resultItems.push(item.dataset.id);
              });

              if(sortValues) {
                sortValues.value = resultItems.join(',');
              }
            }
          },
        });

      }

      const listSource = form.querySelector('[data-sortable-list="source"]');
      if(listSource) {
        const sListSource = Sortable.create(listSource,{
          animation: 150,
          delay: 150,
          delayOnTouchOnly: true,
          easing: "cubic-bezier(1, 0, 0, 1)",
          dragoverBubble: true,
          group: {
            name: 'expose-sort',
          },
          onEnd: function (evt) {
            const items = evt.to.querySelectorAll('.c-sortable__item')
            if(items) {
              if(items.length < 3) {
                evt.to.classList.remove('c-sortable--max');
              } else {
                evt.to.classList.add('c-sortable--max');
              }
              if(items.length < 1) {
                evt.to.classList.remove('c-sortable--visible');
              } else {
                evt.to.classList.add('c-sortable--visible');
              }
              let resultItems = [];
              items.forEach(item => {
                resultItems.push(item.dataset.id);
              });

              if(sortValues) {
                sortValues.value = resultItems.join(',');
              }
            }
          },
        });

      }

      jQuery('form').on('wpcf7cf_repeater_added', function(e) {
        const inputs = e.target.querySelectorAll('.c-input--mask-date');
        if (inputs) {
          inputs.forEach(input => {
            const inputElement = input.querySelector('input');
            const dateMask = IMask(inputElement, {
              mask: Date,
            });
          });
        }
      });

      // # form field input listener
      const inputs = form.querySelectorAll('.c-input');
      if (inputs) {
        inputs.forEach(input => {
          const inputElement = input.querySelector('input, textarea, .wpcf7-radio');

          if(input.classList.contains('c-input--mask-date')) {
            const dateMask = IMask(inputElement, {
              mask: Date,
            });
          }

          if (inputElement) {
            if (inputElement.classList.contains('wpcf7-radio')) {
              const radioElements = inputElement.querySelectorAll('label');
              if (radioElements) {
                radioElements.forEach(radio => {
                  radio.addEventListener('click', () => {
                    const errorNotification = inputElement.nextElementSibling;
                    if (errorNotification && errorNotification.classList.contains('wpcf7-not-valid-tip')) {
                      input.classList.remove('c-input--error');
                      inputElement.classList.remove('wpcf7-not-valid');
                      errorNotification.remove();
                    }
                  });
                });
              }
            } else {
              inputElement.addEventListener('blur', () => {
                if (inputElement.value !== '') {
                  const errorNotification = inputElement.nextElementSibling;
                  if (errorNotification && errorNotification.classList.contains('wpcf7-not-valid-tip')) {
                    input.classList.remove('c-input--error');
                    inputElement.classList.remove('wpcf7-not-valid');
                    errorNotification.remove();
                  }
                }
              });
            }
          }
        });
      }

      // # form file fields
      const fileInputs = form.querySelectorAll('.c-input__dropzone');
      if (fileInputs) {
        fileInputs.forEach(input => {
          const inputElement = input.querySelector('input');
          const btn = input.querySelector('.c-input__dropzone__button');

          const removeBtn = document.createElement('span');
          removeBtn.classList.add('c-input__dropzone__remove');
          removeBtn.innerHTML = '<svg><use xlink:href="#icon-close"></use></svg>';
          removeBtn.addEventListener('click',() => {
            inputElement.value = '';
            inputElement.dispatchEvent(new Event('change'));
          });

          input.parentElement.appendChild(removeBtn)

          const icon = input.querySelector('.c-input__dropzone__placeholder');
          if(icon) {
            icon.innerHTML = '<svg><use xlink:href="#icon-upload"></use></svg> <span data-file-name="Datei auswählen">Datei auswählen</span><span class="is-hidden-mobile is-hidden-tablet-only">&nbsp;oder hier ablegen</span>';
          }

          inputElement.addEventListener('change', e => {
            let fileName = '';
            fileName = e.target.value.split('\\').pop();
            if (fileName) {
              input.classList.add('c-input__dropzone--filled');
              icon.querySelector('[data-file-name]').innerHTML = fileName;
            } else {
              input.classList.remove('c-input__dropzone--filled');
              icon.querySelector('[data-file-name]').innerHTML = icon.querySelector('[data-file-name]').dataset.fileName;
            }
          });
        });
      }

      jQuery('form').on('wpcf7cf_repeater_added', function(e) {
        // # form file fields
        const fileInputs = e.target.querySelectorAll('.c-input__dropzone');
        if (fileInputs) {
          fileInputs.forEach(input => {
            const inputElement = input.querySelector('input');
            const btn = input.querySelector('.c-input__dropzone__button');

            const removeBtn = document.createElement('span');
            removeBtn.classList.add('c-input__dropzone__remove');
            removeBtn.innerHTML = '<svg><use xlink:href="#icon-close"></use></svg>';
            removeBtn.addEventListener('click',() => {
              inputElement.value = '';
              inputElement.dispatchEvent(new Event('change'));
            });

            input.parentElement.appendChild(removeBtn)

            const icon = input.querySelector('.c-input__dropzone__placeholder');
            if(icon) {
              icon.innerHTML = '<svg><use xlink:href="#icon-upload"></use></svg> <span data-file-name="Datei auswählen">Datei auswählen</span><span class="is-hidden-mobile is-hidden-tablet-only">&nbsp;oder hier ablegen</span>';
            }

            inputElement.addEventListener('change', e => {
              let fileName = '';
              fileName = e.target.value.split('\\').pop();
              if (fileName) {
                input.classList.add('c-input__dropzone--filled');
                icon.querySelector('[data-file-name]').innerHTML = fileName;
              } else {
                input.classList.remove('c-input__dropzone--filled');
                icon.querySelector('[data-file-name]').innerHTML = icon.querySelector('[data-file-name]').dataset.fileName;
              }
            });
          });
        }
      });

      // # form validation
      form.addEventListener('wpcf7invalid',event => {
          const formInputs = form.querySelectorAll('.c-input');
          if (formInputs) {
            formInputs.forEach(input => {
              const inputElement = input.querySelector('input, textarea, .wpcf7-radio');
              setTimeout(() => {
                if (inputElement && inputElement.classList.contains('wpcf7-not-valid')) {
                  input.classList.add('c-input--error');
                }
              },300)
            });
            setTimeout(() => {
              const scrollTo = document.querySelector('#' + event.detail.unitTag + ' .c-input--error');
              if(scrollTo) {
                formScroll.animateScroll(scrollTo);
              }
            },500)
          }
      },false);

      // # clear error states on mail sent success
      form.addEventListener('wpcf7mailsent',event => {
        const formInputs = form.querySelectorAll('.form-group');
        if (formInputs) {
          formInputs.forEach(input => {
            const inputElement = input.querySelector('input, textarea, .wpcf7-radio');
            setTimeout(() => {
              if (inputElement) {
                input.classList.remove('c-input--error');
              }
            },300)
          });
        }
      },false);
    });

  }
};

formValidation();

const formElements = document.querySelectorAll('.c-widget--form')
const setFormHeight = () => {
  formElements.forEach(formElement => {
    const bgAnchorElement = formElement.querySelector('.c-form__content')
    const bgAnchorBox = bgAnchorElement.getBoundingClientRect()
    const bgPaddingTop = window.getComputedStyle(formElement, null).getPropertyValue('padding-top')
    formElement.style.setProperty('--bg-relative-height-offset', `${bgAnchorBox.height + parseFloat(bgPaddingTop)}px`)
  });
}

if (formElements) {
  setFormHeight()
  window.addEventListener('resize', _throttle(() => setFormHeight(), 500))
}


